export enum ReportLayoutActionType {
  AddViz = 'layout.addViz',
  CreateChart = 'layout.createChart',
  CloneChart = 'layout.cloneChart',
  CreateText = 'layout.createText',

  RemoveViz = 'layout.removeViz',
  SetRowHeight = 'layout.setRowHeight',
  SetFullTable = 'layout.setFullTable',
  SetAutoTable = 'layout.setAutoTable',
  ToggleTextMargins = 'layout.toggleTextMargins',
  UpdateText = 'layout.updateText',

  ResizeGridElement = 'layout.resizeGridElement',
  MoveGridElement = 'layout.moveGridElement',

  ReloadFrame = 'layout.reloadFrame',
}
